/* eslint-disable react/no-unknown-property */

import { h } from 'preact';
import SVGWrapper from '../../SvgWrapper';

function InfosActiveIcon({ height = 60, width = 60, color = 'white', ...props }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path clip-rule="evenodd" d="m12 22.2002c5.6333 0 10.2002-4.5669 10.2002-10.2002s-4.5669-10.2002-10.2002-10.2002-10.2002 4.5669-10.2002 10.2002c.00001 5.6333 4.5669 10.2002 10.2002 10.2002zm0-12.9004c-.4969 0-.9002-.40253-.9004-.89941 0-.49706.4033-.90039.9004-.90039s.9004.40333.9004.90039c-.0002.49688-.4035.89941-.9004.89941zm-.6748 7.2002v-6h1.3496v6z" fill={color} fill-rule="evenodd" />
    </SVGWrapper>
  );
}

export default InfosActiveIcon;
